import dayjs from "global/dayjs";
import { QueryResultColumnModel } from "services/api/cplapi/CPLAPI";

export const isNumeric = (t: string) => ["Int32", "Int64", "Decimal", "Double", "Single"].includes(t);

export const columnType = (column: QueryResultColumnModel | undefined) => column?.typeName ?? "string";

export const formatCell = (value: unknown, typeName: string): string => {
  if (value == undefined) {
    return "N/A";
  }

  if (typeName === "DateTime" && typeof value === "string") {
    return dayjs(value).format("DD/MM/YYYY");
  }

  if (typeName === "Boolean") {
    return value ? "Yes" : "No";
  }

  if (isNumeric(typeName) && typeof value === "number") {
    return value.toLocaleString();
  }

  return String(value);
};

export const compareValues = (a: unknown, b: unknown, typeName: string): number => {
  if (a == undefined && b == undefined) {
    return 0;
  }
  if (a == undefined) {
    return 1;
  }
  if (b == undefined) {
    return -1;
  }

  if (isNumeric(typeName)) {
    return (a as number) - (b as number);
  }

  if (typeName === "DateTime") {
    return new Date(a as string).getTime() - new Date(b as string).getTime();
  }

  if (typeName === "Boolean") {
    return a === b ? 0 : a ? -1 : 1;
  }

  return String(a).localeCompare(String(b));
};

// Spreadsheet apps run text starting with these as a formula
const FORMULA_PREFIXES = ["=", "+", "-", "@", "\t", "\r"];

const toCsvCell = (value: unknown, typeName: string) => {
  if (value == undefined) {
    return "";
  }

  let text = String(value);
  if (!isNumeric(typeName) && FORMULA_PREFIXES.some((prefix) => text.startsWith(prefix))) {
    text = `'${text}`;
  }

  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const toCsv = (columns: QueryResultColumnModel[], rows: unknown[][]) => {
  const header = columns.map((c) => toCsvCell(c.name, "String"));
  const body = rows.map((row) => columns.map((c, i) => toCsvCell(row[i], columnType(c))));
  return [header, ...body].map((line) => line.join(",")).join("\r\n");
};
